export const GET_DATA_LOADING = "GET_DATA_LOADING"; 
export const GET_DATA_SUCCESS = "GET_DATA_SUCCESS"; 
export const GET_DATA_ERROR = "GET_DATA_ERROR"; 
export const SET_GENDER = "SET_GENDER"; 
export const SET_CATEGORY = "SET_CATEGORY"; 
export const SET_SORT = "SET_SORT"; 
export const SET_GRID = "SET_GRID"; 
export const SET_PAGE = "SET_PAGE"; 
export const RESET_FILTER = "RESET_FILTER"; 
